var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworkLost = function SvgNetworkLost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 573.521 573.522"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#89898b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.308 106.87a25.623 25.623 0 0 0-25.7 25.7v308.425a25.624 25.624 0 0 0 25.7 25.7h25.7a25.623 25.623 0 0 0 25.7-25.7V132.57a25.623 25.623 0 0 0-25.7-25.7Z",
    "data-name": "Path 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.5 183.976a25.623 25.623 0 0 0-25.7 25.7v231.319a25.623 25.623 0 0 0 25.7 25.7h25.7a25.623 25.623 0 0 0 25.7-25.7V209.676a25.623 25.623 0 0 0-25.7-25.7Z",
    "data-name": "Path 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.693 261.081a25.623 25.623 0 0 0-25.7 25.7v154.213a25.623 25.623 0 0 0 25.7 25.7h25.7a25.623 25.623 0 0 0 25.7-25.7V286.781a25.623 25.623 0 0 0-25.7-25.7Z",
    "data-name": "Path 3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f34336",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 54,
    d: "M470.439 470.439c101.443-101.443 101.443-265.914 0-367.357s-265.914-101.443-367.352 0M470.439 470.44c-101.443 101.448-265.914 101.448-367.352 0s-101.448-265.914 0-367.352M470.439 470.44 103.082 103.083"
  })));
};
export default SvgNetworkLost;